import { render, staticRenderFns } from "./SmartDisplayC.vue?vue&type=template&id=c45cb64c&scoped=true"
import script from "./SmartDisplayC.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartDisplayC.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45cb64c",
  null
  
)

export default component.exports